import { createContext } from 'react';

import { DialerContextValues } from '@app/types/Dialer';

const DialerContext = createContext<DialerContextValues | undefined>(undefined);

export default DialerContext;
